module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-area"
  }, [_c('div', {
    staticClass: "search-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    staticClass: "d-md-flex justify-content-between",
    attrs: {
      "action": "#"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("All Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Part Time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Full Time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Remote")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Office Job")])]), _vm._v(" "), _c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Rajshahi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Barishal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Noakhali")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Keyword",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Search Keyword'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("find job")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center mt-5"
  }, [_c('span', [_vm._v("49 Results found for “Telecommunication”")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Assistant Executive - Production/ Quality Control")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn1",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Asst. Manager, Production (Woven Dyeing)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job2.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn2",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Deputy Manager/ Assistant Manager - Footwear")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job3.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn3",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("R&D Manager (Technical Lab Department)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job4.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-job d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Manager/ Asst. Manager (Quality Assurance)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job5.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn2",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "more-job-btn mt-5 text-center"
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("more job post")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d6736f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobSearch.vue
// module id = 242
// module chunks = 1